<!-- Main Page Start -->
<section class="skillsWrap">
  <div class="left-sidebar">
    <app-sidebar></app-sidebar>
  </div>
  <div class="right-panel">

      <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="topHeader">
              <h2 class="mainTitle">Awards & honors</h2>
              <a href="javascript:void(0)" routerLink="/licenese" class="skipBtn"> Skip </a>
          </div>
          <div class="row">

              <div class="col-md-6 col-lg-6  col-sm-12">
                  <div class="form-group">
                      <label>Title <span class="orangeText">*</span> </label>
                      <input type="text"  class="form-control upper" placeholder="Enter" formControlName="name" maxlength="50">
                      <div class="text-danger" *ngIf="form.controls['name'].hasError('required') && showError">
                          *Please enter title.
                      </div>
                  </div>
              </div>
              <div class="col-md-6 col-lg-6 col-sm-12">
                  <div class="form-group">
                      <label>Associated with</label>
                      <input type="text"  class="form-control upper" placeholder="Enter" formControlName="associatedWith">
                      <div class="text-danger" *ngIf="form.controls['associatedWith'].hasError('required') && showError">
                          *Please enter associated with.
                      </div>
                  </div>
              </div>
             

              <div class="col-md-6 col-lg-6 col-sm-12 ">
                  <div class="form-group">
                      <label>Issuer</label>
                      <input type="text"  class="form-control upper" placeholder="Enter" formControlName="issuer">
                      <div class="text-danger" *ngIf="form.controls['issuer'].hasError('required') && showError">
                          *Please enter issuer.
                      </div>
                  </div>
              </div>
              <div class="col-md-6 col-lg-6 col-sm-12 "> 
                      <div class="form-group">
                          <label> Issue date</label>
                          <div id="date-picker-example" class="datepicker">
                            <input type="text" autocomplete="off" class="form-control" placeholder="Enter date" bsDatepicker placement="bottom" [bsValue]="form.value.issuesedOn" [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }" formControlName="issuesedOn" [maxDate]="maxDate" (keydown)="onKeyDown($event)">
                            <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                        </div>
                        <div class="text-danger" *ngIf="showError == true && form.controls['issuesedOn'].hasError('required')">*Please select Issue date</div>
                      </div>                       
              </div>
              
              <div class="col-md-12 col-lg-12  col-sm-12">  
                  <div class="form-group">
                      <label>Description</label>
                      <textarea type="text" class="form-control" placeholder="The bachelor of commerce (BCom) will provide you with a broad foundation knowledge of contemporary business and its practices." formControlName="description" maxlength="250"></textarea>
                      <div class="text-danger" *ngIf="form.controls['description'].hasError('required') && showError">
                          *Please enter description.
                      </div>
                      <div class="text-danger" *ngIf="form.controls['description'].hasError('minlength') && showError">
                          *Minimum length of 3 characters.
                      </div>
                      <div class="text-danger" *ngIf="form.controls['description'].hasError('maxlength') && showError">
                          *Minimum length of 250 characters.
                      </div>
                  </div>
            </div>
          
            </div>                

          <div class="form-group bottom ">
            <input type="submit" value="Save" class="commonBtn width50 mt-2">
              <!-- <a href="javascript:void(0)" routerLink="/awards/add" class="commonBtn width50 mt-2"> Save </a> -->
          </div>
    
      </form>
  </div>
</section>

<!-- End -->
